<template>
      <v-dialog
      v-model="showForm"
      persistent
      max-width="460"
      class="participants mx-auto overflow-hidden"
    >
    <v-card
      class="d-flex flex-row mx-auto overflow-hidden"
      flat
      width="460"
      tile
    >
      <v-card>
        <v-card-title class="text-h5">
          <span class="participants-title" v-html="$t('videoconf.participantsDialog.title', { name: videoConference.name })"></span>
        </v-card-title>

        <v-card max-height="600px" style="overflow-y: scroll" elevation="0">
          <v-list dense width="445">
            <v-list-item-group>
              <v-list-item
                v-for="(participant) in participants"
                :key="participant.extension"
                style="display: -webkit-box !important;"
              >
                  <v-list-item-action>
                    <StatusAvatar :user="getUser(participant.extension)"/>
                  </v-list-item-action>

                  <v-list-item-content style="margin: 0px !important;min-width: 145px !important;">
                    <v-list-item-title> {{ participant.name }} <v-icon small color="green" v-if="participant.isAdmin">mdi-shield-account</v-icon></v-list-item-title>
                    <v-list-item-subtitle v-html="$t('videoconf.extension', { extension: participant.extension })"></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action style="margin: 0px !important;">
                  </v-list-item-action>

                  <v-list-item-action style="margin: 0px !important;">
                    <v-list-item-action-text v-if="participant.isAdmin" v-text="$t('videoconf.participantsDialog.admin')"></v-list-item-action-text>
                    <v-list-item-action-text v-else v-text="$t('videoconf.participantsDialog.member')"></v-list-item-action-text>
                  </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="$emit('close')"
          >
            {{ $t('videoconf.participantsDialog.btn.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import StatusAvatar from '@/components/buddies/status_avatar'
import VideoConference from 'Store/class/video_conference'
import API from '@/api'

export default {
  name: 'video-conference-participants-dialog',
  components: { StatusAvatar },
  props: {
    showForm: { type: Boolean, default: false },
    videoConference: { type: VideoConference, default () { return new VideoConference() } }
  },
  data () {
    return {
      participantsList: []
    }
  },
  computed: {
    ...mapGetters({
      users: 'users/listAll'
    }),

    participants: function () {
      if (this.participantsList.length) {
        return this.participantsList
      }
      const formattedAdmins = (this.videoConference?.admins || []).map((admin) => ({
        name: admin.name,
        extension: admin.extension,
        isAdmin: true
      }))
      const formattedUsers = (this.videoConference?.users || []).map((user) => ({
        name: user.name,
        extension: user.extension,
        isAdmin: false
      }))
      return formattedAdmins.concat(formattedUsers)
    }
  },
  watch: {
    showForm (val) {
      if (val) {
        this.loadParticipants()
      }
    }
  },
  methods: {
    async loadParticipants () {
      const response = await API.getVideoConference(this.videoConference?.id)
      const videoConference = response?.data || {}
      const formattedAdmins = (videoConference.admins || []).map((admin) => ({
        name: admin.name,
        extension: admin.extension,
        isAdmin: true
      }))
      const formattedUsers = (videoConference.users || []).map((user) => ({
        name: user.name,
        extension: user.extension,
        isAdmin: false
      }))
      this.participantsList = formattedAdmins.concat(formattedUsers)
    },
    getUser (extension) {
      return this.users.find((user) => user.exten === extension)
    }
  }
}
</script>

<style>
</style>
